import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import SheetCapture from './ctn/SheetCapture';
import $ from 'jquery';
import { utils, writeFile } from 'xlsx';
import Select, { components, createFilter } from 'react-select';
import { capitalizeFLetter, ajaxPerso, roundPrice, socketPerso } from '../fnc'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons'
import moment from 'moment';
const refConst = require("../constants.js").v

const {info, log, warn} = console
const initialState = {
	dataSheet: null,
	resTrigger: null,
	costReportRes: null,
	costReportFileName: '',
	minDataSheet: null,
	minResTrigger: null,
	submited: false,
	isMapReprice: false,
	idTask: null,
	refreshPage: 0,
};


export default function Repricer(props){

	const apiProperty = [{
		api: "ebay",
		name: "eBay - EIO",
		hasAccess: props.securityClearance(props, [
			"-MjVxK86GVBUKL5oNU66", // admin_access
			"-MjVTgFHd2akT44hrjKg", // ebay_eio_write
		]),
		fnc: () => triggerFnc("eBay - EIO", "ebay", { shop: refConst.id_store_eBay_EIO }, (r) => {
			console.info('rrrrr', r);
			if(r.errors){
				props.info({error: r.errors})
			}
			/**
			 * 
			 * {
					"success": "Items updated",
					"error": false,
					"data": {
						"updated": [
							{
								"sku": "ESWG-E3-WC",
								"new Price": 33.36,
								"old Price": 33.5
							},
							{
								"sku": "3M-7000006045",
								"new Price": 329.99,
								"old Price": 330.99
							}
						],
						"notUpdated": [],
						"dbUpdated": []
					},
					"time": 5.458504,
					"type": "repricer"
				}
			 */
		}),
		val: [{
			required: ["sku", "price"]
		}, {
			required: ["sku", "percentage"]
		}]
	}, {
		api: "ebay",
		name: "eBay - YWE",
		hasAccess: props.securityClearance(props, [
			"-MjVxK86GVBUKL5oNU66", // admin_access
			"-MjVTgFHd2akT44hrjKg", // ebay_eio_write
		]),
		fnc: () => triggerFnc("eBay - YWE", "ebay", { shop: refConst.id_store_eBay_EIO }, (r) => {
			console.info('rrrrr', r);
			if(r.errors){
				props.info({error: r.errors})
			}
		}),
		val: [{
			required: ["sku", "price"]
		}, {
			required: ["sku", "percentage"]
		}]
	}, {
		api: "shopify",
		name: "EIO.com",
		hasAccess: props.securityClearance(props, [
			"-MjVxK86GVBUKL5oNU66", // admin_access
			"-MjH_9MuY646871R7lUA", // shopify_eio_write
		]),
		fnc: () => triggerFnc("eio", "shopify", { shop: refConst.id_store_eio }, (r) => {
			console.info('rrrrr', r);
			if(r.errors){
				props.info({error: r.errors})
			}
			/**
			{
				"success": "Items updated",
				"error": false,
				"data": {
					"updated": [
						{
							"sku": "ESWG-E3-WC",
							"new Price": 31.27,
							"old Price": 33.36
						},
						{
							"sku": "3M-7000006045",
							"new Price": 311.99,
							"old Price": 329.99
						}
					],
					"notUpdated": [],
					"dbUpdated": []
				},
				"time": 5.949199,
				"type": "repricer"
			}
			 */
		}),
		val: [{
			required: ["sku", "price"]
		}, {
			required: ["sku", "percentage"]
		}]
	}, {
		api: "shopify",
		name: "Haus of Tools",
		hasAccess: props.securityClearance(props, [
			"-MjVxK86GVBUKL5oNU66", // admin_access
			"-MjVTYrT8L8HguYYrRKE", // shopify_haus_write
		]),
		fnc: () => triggerFnc("hausOfTools", "shopify", { shop: refConst.id_store_hausfTools }, (r) => {
			console.info('rrrrr', r);
			if(r.errors){
				props.info({error: r.errors})
			}
		}),
		val: [{
			required: ["sku", "price"]
		}, {
			required: ["sku", "percentage"]
		}]
	}, {
		api: "walmart",
		name: "Walmart- EIO",
		hasAccess: props.securityClearance(props, [
			"-MjVxK86GVBUKL5oNU66", // admin_access
			"-MjWGqGi59xNbduybZHA", // walmart_eio_write
		]),
		fnc: () => triggerFnc("Walmart - EIO", "walmart", { shop: refConst.id_store_walmart_eio }, (r) => {
			console.info('rrrrr', r);
			if(r.errors){
				props.info({error: r.errors})
			}
		}),
		val: [{
			required: ["sku", "price"]
		}, {
			required: ["sku", "percentage"]
		}]
	}, {
		api: "amazon",
		name: "Amazon - EIO",
		shop: refConst.id_store_amazon_EIO,
		hasAccess: props.securityClearance(props, [
			"-MjVxK86GVBUKL5oNU66", // admin_access
			"-MjWHEUEG0HJvoZtpe19", // amazon_eio_write
		]),
		fnc: () => triggerFnc("Amazon - EIO", "amazon", { shop: refConst.id_store_amazon_EIO }, (r) => {
			console.info('rrrrr', r);
			if(r.errors){
				props.info({error: r.errors})
			}
		}),
		val: [{
			required: ["sku", "price"]
		}, {
			required: ["sku", "percentage"]
		}]
	}, {
		api: "amazon",
		name: "Amazon - GOTT",
		shop: refConst.id_store_amazon_GOTT,
		hasAccess: props.securityClearance(props, [
			"-MjVxK86GVBUKL5oNU66", // admin_access
			"-MjWHEUEG0HJvoZtpe19", // amazon_eio_write
		]),
		fnc: () => triggerFnc("Amazon - GOTT", "amazon", { shop: refConst.id_store_amazon_GOTT }, (r) => {
			console.info('rrrrr', r);
			if(r.errors){
				props.info({error: r.errors})
			}
		}),
		val: [{
			required: ["sku", "price"]
		}, {
			required: ["sku", "percentage"]
		}]
	}].filter(o => o.hasAccess)

	const [selectedStore, setSelectedStore] = useState(apiProperty.length > 0 ? apiProperty[0].name : null);
	const [dataSheet, setDataSheet] = useState(initialState.dataSheet);
	const [resTrigger, setResTrigger] = useState(initialState.resTrigger);
	const [costReportRes, setCostReportRes] = useState(initialState.costReportRes);
	const [minDataSheet, setMinDataSheet] = useState(initialState.minDataSheet);
	const [minResTrigger, setMinResTrigger] = useState(initialState.minResTrigger);
	const [submited, setSubmited] = useState(initialState.submited);
	const [isMapReprice, setIsMapReprice] = useState(initialState.isMapReprice);
	const [costReportFileName, setCostReportFileName] = useState(initialState.costReportFileName);
	const [idTask, setIdTask] = useState(initialState.idTask);
	const [refreshPage, setRefreshPage] = useState(initialState.refreshPage);

	useEffect(() => {

		socket.on('bulkRepriceEvent', function(idTask){
			console.info("Id Task", idTask);
			setIdTask(idTask)
		})

	}, [])

	useEffect(() => {
		info('dataSheet', dataSheet);
	}, [dataSheet])

	useEffect(() => {
		resetPage()
	}, [selectedStore])

	useEffect(() => {
		props.loading(submited)
	}, [submited])

	useEffect(() => {
		// force file download
		dlDetails(resTrigger, 'MAP_Reprice');
	}, [resTrigger])

	useEffect(() => {
		dlDetails(minResTrigger, 'Min_Allowed_Price');
	}, [minResTrigger])

	useEffect(() => {
		$('.tooltipInfoMap').tooltip({
			placement: "right",
			title: "When checked, the prices will be updated only if smaller than your new price (map)."
		}).tooltip('update')
	})

	// Recover from bad state (e.g. legacy bug set selectedStore to an object when clearing the Select)
	useEffect(() => {
		if (selectedStore != null && typeof selectedStore !== 'string') {
			setSelectedStore(apiProperty.length > 0 ? apiProperty[0].name : null)
		}
	}, [selectedStore, apiProperty.length])

	let resetPage = () => {
		for (const key in initialState) {
			if (initialState.hasOwnProperty(key)) {
				let val = JSON.parse(JSON.stringify(initialState[key]))
				console.info('Eval result', eval("set" + capitalizeFLetter(key))(val));
			}
		}
	}

	let dlDetails = (activeResTrigger = null, fileLabel = 'MAP_Reprice') => {
		if(!activeResTrigger)	return false
		const storeForDl = findStore(selectedStore)
		if (!storeForDl || !storeForDl.api) {
			console.warn('dlDetails: no store selected')
			return false
		}
		try{
			console.info("resTriggerresTrigger", activeResTrigger);
			var book  = utils.book_new()
	
			console.info('api', storeForDl.api);
	
			if (activeResTrigger?.updated && !Array.isArray(activeResTrigger.updated)) {
				activeResTrigger.updated = Object.values(activeResTrigger.updated);
			}
			if (activeResTrigger?.notUpdated && !Array.isArray(activeResTrigger.notUpdated)) {
				activeResTrigger.notUpdated = Object.values(activeResTrigger.notUpdated);
			}
			if (activeResTrigger?.skuDuplicateList && activeResTrigger.skuDuplicateList.length > 0) {
				activeResTrigger.skuDuplicateList = {
					sku: activeResTrigger.skuDuplicateList,
				};
			}else{
				activeResTrigger.skuDuplicateList = null
			}
			
			switch (storeForDl.api.toLowerCase()) {
			case "ebay":
				if(activeResTrigger?.updated)
					utils.book_append_sheet(book, utils.json_to_sheet(correctReturnedArray(activeResTrigger.updated)), "Details");
				if(activeResTrigger?.notUpdated)
					utils.book_append_sheet(book,  utils.json_to_sheet(correctReturnedArray(activeResTrigger.notUpdated)), "Errors");
				if(activeResTrigger?.dbUpdated)
					utils.book_append_sheet(book,  utils.json_to_sheet(activeResTrigger.dbUpdated), "DB Updated");
				if(activeResTrigger?.skuDuplicateList)
					utils.book_append_sheet(book, utils.json_to_sheet(activeResTrigger.skuDuplicateList), "sku Duplicate");
				break;
			case "shopify":
				if(Array.isArray(activeResTrigger.updated) && activeResTrigger.updated.length > 0)
					activeResTrigger.updated.forEach(o => {
						o.status = [200, 201].indexOf(o.code) !== -1? "success" : "error";
					});
		
				if(activeResTrigger?.updated)
					utils.book_append_sheet(book, utils.json_to_sheet(activeResTrigger.updated), "Details");
				if(activeResTrigger?.notUpdated)
					utils.book_append_sheet(book, utils.json_to_sheet(activeResTrigger.notUpdated), "Errors");
				if(activeResTrigger?.skuDuplicateList)
					utils.book_append_sheet(book, utils.json_to_sheet(activeResTrigger.skuDuplicateList), "sku Duplicate");
				break;
			case "amazon":
				if(activeResTrigger?.updated)
					utils.book_append_sheet(book, utils.json_to_sheet(activeResTrigger.updated), "Details");
				if(activeResTrigger?.notUpdated)
					utils.book_append_sheet(book, utils.json_to_sheet(activeResTrigger.notUpdated), "Errors");
				if(activeResTrigger?.summary){
					// Convert object of properties to array of objects for the sheet
					const summaryArray = Object.entries(activeResTrigger.summary).map(([key, value]) => {
						return { Property: key, Value: value };
					});
					utils.book_append_sheet(book, utils.json_to_sheet(summaryArray), "Summary");
				}
				break;
			case "walmart":
				if(activeResTrigger?.updated)
					utils.book_append_sheet(book, utils.json_to_sheet(activeResTrigger.updated), "Details");
				if(activeResTrigger?.notUpdated)
					utils.book_append_sheet(book, utils.json_to_sheet(activeResTrigger.notUpdated), "Errors");
				break;
			default:
				break;
			}
			
			if(activeResTrigger?.updated?.length > 0 || activeResTrigger?.notUpdated?.length > 0 || activeResTrigger?.dbUpdated?.length > 0)
				writeFile(book, `Result_${selectedStore}_${fileLabel}_${moment().local().format('YYYY-MM-DD hh:mm:ss')}.xlsx`)
		}catch(e){
			console.error("resTriggerresTrigger", e);
		}
	}

	const modalConfirmation = (mode, callback) => {
		props.modal({
			show: true,
			title: mode === 'minimum'? "Confirmation - Update minimum allowed price" : "Confirmation - Reprice",
			html: () => {
				if(mode === 'minimum'){
					return <div>
						<p className="text-center">This action updates the Amazon minimum allowed price for every matching SKU in your sheet.</p>
						<p className="text-center text-danger font-weight-bold">It does not change the live selling price. Use this section to force the floor for all listed Amazon items.</p>
					</div>
				}

				return <div>
					{
						mode === 'costReport' ? <div className="text-center">
							<p className="text-center"><span className="font-weight-bold">Cost report repricing</span> will update items based on the selected 3M report.</p>
							<p className="text-center text-danger font-weight-bold">You can keep the file name empty to let the server pick the latest report automatically.</p>
						</div> : isMapReprice ? <div className="text-center">
							<p className="text-center">You have selected <span className="font-weight-bold">MAP Reprice</span></p>
							<p className="text-center text-danger font-weight-bold">Please make sure that your price column in your xslx file represent the MAP LIMIT, any items that match your selected sku and brake your map price will be adjusted to reflect your new map.</p>
						</div> : <div>
							<p className="text-center"><span className="font-weight-bold">MAP Reprice</span> is unselected</p>
							<p className="text-center text-danger font-weight-bold">Any items matching your selected sku list will be updated with your new selected price, please make sure that you price column is accurate.</p>
						</div>
					}
				</div>
			}
			,ok: {
				title: "I'm sure",
				fnc: (popup, close) => {
					if(callback)	callback()
					close()
				}
			},
			return: {
				title: "Close"
			}
		})
	}

	let correctReturnedArray = (list) => {
		list.forEach(obj => {
			for (const key in obj) {
				if (Object.hasOwnProperty.call(obj, key)) {
					if(Array.isArray(obj[key]))
						obj[key] = obj[key].join(', ')
				}
			}
		})
		return list;
	}

	const showDifference = (sheetSelected, triggerResult, fileLabel) => {
		if(sheetSelected && triggerResult !== null){
			const updatedCount = Array.isArray(triggerResult?.updated) ? triggerResult.updated.length : Number((triggerResult?.summary?.items_repriced || triggerResult?.summary?.updated_count || triggerResult?.summary?.items_to_update || 0))
			const notUpdatedCount = Array.isArray(triggerResult?.notUpdated) ? triggerResult.notUpdated.length : Number((triggerResult?.summary?.errors_count || 0))

			return <div>
				<table className="table table-sm">
					<thead>
						<tr>
							<th scope="col">Result</th>
							<th scope="col">Quantity</th>
						</tr>
					</thead>
					<tbody>
						<tr className="table-success"><td>Updated</td><td>{updatedCount}</td></tr>
						<tr className="table-danger"><td>Errors</td><td>{notUpdatedCount}</td></tr>
						{triggerResult?.summary?.source_file ? <tr><td>Source file</td><td><small>{triggerResult.summary.source_file}</small></td></tr> : null}
						<tr className="border-top"><td className="align-middle">Details</td><td><button type="button" className="btn btn-primary btn-sm" onClick={() => dlDetails(triggerResult, fileLabel)}>Download</button></td></tr>
					</tbody>
				</table>
			</div>
		}
	}

	const triggerPageFnc = () => {
		const store = findStore(selectedStore)
		if (!store) {
			props.info({error: "Please select a store."})
			return
		}
		if(!dataSheet){
			props.info({error: "Please select a file, a sheet and a column to compare it with your marketplace."})
		}else{
			setSubmited(true)
			store.fnc()
		}
	}

	const triggerCostReportFnc = () => {
		const store = findStore(selectedStore)
		if (!store) {
			props.info({error: "Please select a store."})
			return
		}

		setSubmited(true)
		let args = {
			method: "reprice_from_cost_report",
			shop: store.shop,
			verbose: true,
		}
		if (costReportFileName.trim() !== '') args.fileName = costReportFileName.trim()

		SubmitReq("tools", args, null, {
			triggerName: "3M_reprice",
			skipTypeCheck: true,
			setResult: setCostReportRes,
			taskName: `[${store.shop}] Reprice ${args.fileName ? 'report' : 'latest report'} via cost report`,
			successMessage: "3M cost report repricing completed",
			responseFormatter: "cost_report_reprice",
		})
	}

	const triggerFnc = (storeName, api, shopObj, callback) => {

		console.info('dataSheetdataSheet', dataSheet);

		let newOut = [];
		dataSheet.listObj.forEach((o, i) => {
			if(o.price != "0"){
				o.price = roundPrice(o.price)
				newOut.push(o)
			}
		});

		SubmitReq(api, Object.assign({
			data: JSON.stringify(newOut),
			itemCount: newOut.length,
		}, shopObj), callback)
	}

	const triggerMinAllowedPageFnc = () => {
		const store = findStore(selectedStore)

		if(!minDataSheet){
			props.info({error: "Please select a file, a sheet and the sku/minimum columns."})
		}else if(!store || store.api.toLowerCase() !== 'amazon'){
			props.info({error: "This action is available only for Amazon stores."})
		}else if (!minDataSheet.listObj || !Array.isArray(minDataSheet.listObj)) {
			props.info({error: "Sheet data is missing or invalid. Please re-upload your file."})
		}else{
			setSubmited(true)

			let newOut = []
			minDataSheet.listObj.forEach((o) => {
				if(o.sku !== undefined && o.min_allowed_price !== undefined && String(o.min_allowed_price).trim().length > 0){
					newOut.push({
						sku: String(o.sku).trim(),
						min_allowed_price: roundPrice(o.min_allowed_price),
					})
				}
			})

			SubmitReq('amazon', {
				shop: store.shop,
				data: JSON.stringify(newOut),
				itemCount: newOut.length,
			}, null, {
				triggerName: 'refreshAndBulkUpdateMinAllowedPrice',
				isMapAdjustment: false,
				skipTypeCheck: true,
				setResult: setMinResTrigger,
				successMessage: 'Minimum allowed prices updated',
			})
		}
	}

	const submitData = (api, args, callback, options = {}) => {
		let type = getApiProperty(selectedStore)

		if(!type && !options.skipTypeCheck){
			props.info({error: "No type requived corresponding a test."})
		}else{
			const isAmazonRepricer = api.toLowerCase() === "amazon"
			const triggerName = options.triggerName || "bulkUpdatePrice"
			const isMapAdjustment = Object.prototype.hasOwnProperty.call(options, 'isMapAdjustment')? options.isMapAdjustment : isMapReprice

			/* console.info("bulkUpdatePrice", Object.assign({
				"method": "POST",
				"api": api,
				"trigger": triggerName,
				"isMapAdjustment": isMapAdjustment,
			}, args))

			ajaxPerso( Object.assign({
				"method": "POST",
				"api": api,
				"trigger": triggerName,
				"isMapAdjustment": isMapAdjustment,
			}, args), callback, function(jqXHR, textStatus) {
				setSubmited(false)
				console.warn(textStatus)
			})
			return */

			socketPerso("task", {
				url: refConst.urlServer,
				internalReq: Object.assign({
					"method": "POST",
					"api": api,
					"trigger": triggerName,
					"isMapAdjustment": isMapAdjustment,
				}, args),
				task: {
					op: "update",
					type: "repricer",
					store: args?.shop,
					args: {
						uid: props.getUser().uid,
						name: options?.taskName || `[${args?.shop}] Reprice ${args.itemCount || 0} items on ${api}`
					}
				},
				eventIdTaskName: "bulkRepriceEvent"
			}, callback)
		}
	}

	const normalizeRepriceResult = (response, options = {}) => {
		const payload = response?.data || response?.res || response || {}
		const nestedPayload = payload?.data || payload?.output || payload
		const updated = Array.isArray(nestedPayload?.updated) ? nestedPayload.updated : []
		const notUpdated = Array.isArray(nestedPayload?.notUpdated) ? nestedPayload.notUpdated : []
		const dbUpdated = Array.isArray(nestedPayload?.dbUpdated) ? nestedPayload.dbUpdated : []
		const skuDuplicateList = Array.isArray(nestedPayload?.skuDuplicateList) ? nestedPayload.skuDuplicateList : []
		const summary = nestedPayload?.summary || payload?.summary || null
		const fallbackErrors = Array.isArray(nestedPayload?.errors) ? nestedPayload.errors : []

		if(response?.fnc === "reprice_from_cost_report" || options?.responseFormatter === "cost_report_reprice"){
			const repriceSummary = Object.assign({
				items_to_update: Number(nestedPayload?.items_to_update || 0),
				updated_count: Number(nestedPayload?.reprice?.updated_count || 0),
				errors_count: Number((nestedPayload?.errors_count || fallbackErrors.length || 0)),
				backup_file: nestedPayload?.backup?.backup_file || null,
				result_file: nestedPayload?.reprice?.result_file || nestedPayload?.result_file || null,
				source_file: nestedPayload?.source_file || null,
			}, summary || {})

			return {
				updated: updated,
				notUpdated: notUpdated.length > 0 ? notUpdated : fallbackErrors,
				dbUpdated: dbUpdated,
				skuDuplicateList: skuDuplicateList,
				summary: repriceSummary,
				raw: response,
			}
		}

		return {
			updated,
			notUpdated,
			dbUpdated,
			skuDuplicateList,
			summary,
			raw: response,
		}
	}

	const extractResponseError = (response, normalizedResult) => {
		if (response?.errors) return response.errors
		if (response?.error && response.error !== false) return response.error
		if (response?.data?.errors) return response.data.errors
		if (response?.data?.error && response.data.error !== false) return response.data.error
		if (response?.res?.errors) return response.res.errors
		if (response?.res?.error && response.res.error !== false) return response.res.error
		if (normalizedResult.notUpdated.length > 0) return normalizedResult.notUpdated
		return null
	}

	const SubmitReq = (api, args, callback, options = {}) => {
		submitData(api, args, (r) => {
			setSubmited(false)

			// return false
			//setSubmited(false)
			console.info(`Fetching_bulkUpdatePrice ${api}:`, r);
			const normalizedResult = normalizeRepriceResult(r, options)
			const responseError = extractResponseError(r, normalizedResult)
			if(callback)	callback(r)
			if(r.success){
				const setResult = options.setResult || setResTrigger
				setResult(normalizedResult)
				// if(r.success !== true)	props.info({"success": r.success})
				if(r.success === true)
					r.success = options.successMessage || "Items updated";
			}

			props.info({
				success: r.success ? r.success : null,
				error: responseError,
			})
		}, options)
	}

	const getApiProperty = (store) => {
		if(!dataSheet || !findStore(store))
			return null

		let type = null
		
		let reqSheet = Array.isArray(dataSheet.required)? dataSheet.required : [dataSheet.required]

		findStore(store).val.forEach(r => {
			reqSheet.forEach(r2 => {
				if(r.required.indexOf(r2.toLowerCase()) !== -1){
					type = r
					return false;
				}
			})
		})
		return type
	}

	const findStore = (store) => {
		if (store == null || typeof store !== 'string') return undefined
		return apiProperty.find(s => s.name === store)
	}

	const currentStore = findStore(selectedStore)
	const isAmazonStore = !!currentStore && currentStore.api.toLowerCase() === 'amazon'

	const renderInformationCard = (sheet, actionTitle, buttonLabel, onClick, triggerResult, fileLabel) => {
		if(!sheet)	return null

		return <div className="container mt-4 bg-light p-3 border">
			<p className="font-weight-bolder">{actionTitle}</p>
			<div className="row">
				<div className="col-sm">
					Line number:
				</div>
				<div className="col-sm">
					<span className="font-weight-bolder">{ sheet.sheet.length > 0? sheet.sheet.length-1 : 0 }</span>
				</div>
			</div>
			<div className="row">
				<div className="col-sm">
					The column selected:
				</div>
				<div className="col-sm">
					<span className="font-weight-bolder">{ Array.isArray(sheet.columnName)? sheet.columnName.join(', ') : sheet.columnName }</span>
				</div>
			</div>
			<div className="row">
				<div className="col justify-content-center text-center mt-3">
					<button type="button" className="btn btn-primary btn-lg" onClick={onClick} disabled={submited? true : false}>{buttonLabel}</button>
				</div>
			</div>
			<div className="row">
				<div className="col justify-content-center text-center mt-3">
					{ showDifference(sheet, triggerResult, fileLabel) }
				</div>
			</div>
		</div>
	}

	const renderCostReportCard = () => {
		return <div className="container mb-3 bg-light border p-3">
			<p className="font-weight-bolder">3M cost report repricing</p>
			<p className="mb-2 text-muted">Run repricing from a 3M cost report (new flow). Leave file name empty to auto-pick the latest file.</p>
			<div className="row">
				<div className="col-sm-9">
					<input
						type="text"
						className="form-control"
						value={costReportFileName}
						placeholder="e.g. finale_3M_cost_check_special.xlsx"
						onChange={(e) => setCostReportFileName(e.target.value)}
					/>
				</div>
				<div className="col-sm-3 text-right">
					<button type="button" className="btn btn-primary btn-lg" onClick={() => {modalConfirmation('costReport', triggerCostReportFnc)}} disabled={submited? true : false}>
						Reprice from cost report
					</button>
				</div>
			</div>
			<div className="row">
				<div className="col justify-content-center text-center mt-3">
					{ showDifference(currentStore, costReportRes, '3M_Cost_Report') }
				</div>
			</div>
		</div>
	}

	if(!props.securityClearance(props))	return "";

	if (apiProperty.length === 0) {
		return (
			<div className="main ctnPage">
				<h1 className="page-header mb-4">Repricer</h1>
				<div className="alert alert-warning" role="alert">
					You can open this page, but no repricer channels are enabled for your account. Ask an admin to grant access to at least one marketplace (eBay, Shopify, Amazon, or Walmart).
				</div>
			</div>
		)
	}

	return (
		<div className="main ctnPage">
			<h1 className="page-header mb-4">Repricer</h1>
			<div className="alert alert-primary" role="alert">
				The 3M cost changer report can be uploaded in this tool to increase the product selection from the increased cost percentage.
			</div>
			<div className="container p-3 bg-light border mb-3">
				<p className="font-weight-bolder">Store to compare to</p>
				<div className="d-flex flex-row align-items-center">
					{
						<Select
							className="w-50"
							styles={refConst.styleList}
							onChange={(selectedOption) => {
								setSelectedStore(selectedOption ? selectedOption.value : null)
							}}
							options={(() => {
								return apiProperty.map(b => {
									return {
										value: b.name,
										label: `${b.name}`
									}
								})
							})()}
							value={typeof selectedStore === 'string' && selectedStore ? [{ value: selectedStore, label: selectedStore }] : null}
							placeholder={"Select a store"}
							isSearchable={true}
							isMulti={false}
						/>
					}
					<div className="custom-control custom-switch noselect w-50  text-center">
						<input type="checkbox" className="custom-control-input" id="customSwitchFree" checked={isMapReprice} onChange={(e) => { setIsMapReprice(e.target.checked? true : false) }}/>
						<label className="custom-control-label" htmlFor="customSwitchFree">
							Map Reprice
							<span className="ml-3 tooltipInfoMap" data-toggle="tooltip"><FontAwesomeIcon icon={faQuestionCircle} style={{fontSize: "23px"}}/></span>
						</label>
					</div>
				</div>
			</div>
			<div id="mainMenu" className="container mb-3 bg-light border p-3">
				<p className="font-weight-bolder">Select the primary type of data to use for comparison</p>
				{
					currentStore ? currentStore.val.map((s, pos) => {
						return <SheetCapture key={`${pos}_${s.required}_sheetCapture`} className={"ml-4"} dataSheet={dataSheet} onChange={(val) => {
							setDataSheet(val)
						}} name={`From Sheet [by: ${s.required}]`} {...props} returnAll={true} required={Array.isArray(s.required)? s.required : [s.required]}/>
					}) : (
						<p className="text-muted mb-0">Choose a store above to upload and map your spreadsheet columns.</p>
					)
				}
			</div>
			{
				isAmazonStore? <div className="container mb-3 bg-light border p-3">
					<p className="font-weight-bolder">Amazon minimum allowed price</p>
					<div className="alert alert-warning" role="alert">
						This section updates only the Amazon minimum allowed price. It does not change the live selling price.
					</div>
					<SheetCapture
						className={"ml-4"}
						dataSheet={minDataSheet}
						onChange={(val) => {
							setMinDataSheet(val)
						}}
						name={"From Sheet [by: sku, min price]"}
						{...props}
						returnAll={true}
						required={["sku", "min_allowed_price"]}
						ctnAdded={<li className="font-weight-bold">Map your supplier floor column to min_allowed_price.</li>}
					/>
				</div> : ''
			}
			{
				renderInformationCard(dataSheet, 'Informations', 'Reprice', () => {modalConfirmation('price', triggerPageFnc)}, resTrigger, 'MAP_Reprice')
			}
			{
				renderCostReportCard()
			}
			{
				renderInformationCard(minDataSheet, 'Amazon minimum allowed price import', 'Update minimum', () => {modalConfirmation('minimum', triggerMinAllowedPageFnc)}, minResTrigger, 'Min_Allowed_Price')
			}
		</div>
	);
}